// https://github.com/rails/rails/blob/v7.0.4/activestorage/app/javascript/activestorage/ujs.js#L4
const processingAttribute = "data-direct-uploads-processing";

// Active Storageのダイレクトアップロードによりフォームが二度送信されてしまう問題を回避する。
// ファイルアップロードが始まると processingAttribute が form に付与されるので、それを利用している。
export function preventDuplicatedSubmission(form) {
  const EVENT_NAME = "ajax:before.directUploadUtility:preventDuplicatedSubmission";

  // ダイレクトアップロードと重複して送信されるリクエストはrails-ujs（jQuery）由来。
  // form.addEventListener() では送信を止められないため、敢えて $(form).on() としている。
  $(form).off(EVENT_NAME).on(EVENT_NAME, () => {
    if (form.hasAttribute(processingAttribute)) {
      return false;
    }
  });
}

// Active Storageのダイレクトアップロードにより変更されたフォーム要素をリセットする。
export function reset(form) {
  const progressNodes = form.querySelectorAll(".direct-upload--complete");
  const fileField = form.querySelector(
    'input[type="file"][data-direct-upload-url]'
  );

  // .direct-upload--complete の要素が生成されるので削除する。
  progressNodes.forEach((node) => node.remove());

  if (fileField) {
    // オリジナルの input[type="file"] が無効化されるので改めて有効化する。
    fileField.disabled = false;

    const copiedHiddenFields = form.querySelectorAll(
      `input[type="hidden"][name="${fileField.name}"]`
    );

    for (const copiedHiddenField of copiedHiddenFields) {
      // オリジナルの input[type="file"] と同じ name を持つ input[type="hidden"] が生成されるので削除する。
      // ダイレクトアップロードで生成されたわけではない要素（値が空のダミー要素）は削除しない。
      if (copiedHiddenField.value) {
        copiedHiddenField.remove();
      }
    }
  }
}
